import type { Action } from 'redux';
import type { UserView } from '../types';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const SetUserView = new ReduxAsyncAction<'SET_USER_VIEW', UserView, void>('SET_USER_VIEW');

SetUserView.registerRequest(function (view: UserView) {
  return dash_api
    .post('/v1/dashboard-user/set-view', {
      view,
    })
    .then(() => {
      location.reload();
    })
    .catch(() => {
      NotificationActions.entityError('Error switching view');
    });
});

export const SET_USER_VIEW = SetUserView.actionNamespaceConstants;

export const setUserView = SetUserView.request;

export type SetUserViewResponseAction = Action<typeof SET_USER_VIEW.response>;
